import { render, staticRenderFns } from "./RecorderComp.vue?vue&type=template&id=6f1a4e26&"
import script from "./RecorderComp.vue?vue&type=script&lang=js&"
export * from "./RecorderComp.vue?vue&type=script&lang=js&"
import style0 from "./RecorderComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports